import { API_ROOT, sendRequest } from '../../supplementary_components/requests';

function request(method, path, body, contentType, preSend, notJson) {
    return new Promise((resolve, reject) => {
        sendRequest(
            method,
            API_ROOT + path,
            null,
            resolve,
            (error) => reject(error),
            body,
            contentType,
            preSend,
            notJson,
        );
    });
}

export function hiringErrorMessage(error) {
    if (!error) return 'Something went wrong';
    if (typeof error === 'string') return error;
    return error.customError || error.message || 'Something went wrong';
}

export const hiringApi = {
    list: (pageNumber = 0, pattern = '', category = '') => {
        const params = new URLSearchParams({ pageNumber: String(pageNumber) });
        if (pattern && pattern.trim()) params.set('pattern', pattern.trim());
        if (category) params.set('category', category);
        return request('GET', `potential-drivers?${params.toString()}`);
    },
    phoneLookup: (digits) => request('GET', `phone-lookup?digits=${encodeURIComponent(digits)}`),
    save: (id, body) => request('POST', id ? `potential-drivers/${id}` : 'potential-drivers', body),
    assignCompany: (id, companyId) => request('POST', `potential-drivers/${id}/company`, { companyId }),
    linkTeam: (id, partnerId) => request('POST', `potential-drivers/${id}/team`, { partnerId }),
    unlinkTeam: (id) => request('POST', `potential-drivers/${id}/team/unlink`, {}),
    delete: (id) => request('DELETE', `potential-drivers/${id}`),
    addFile: (id, file) => {
        const body = new FormData();
        body.append('potentialDriverId', id);
        body.append('file', file);
        body.append('fileName', file.name);
        return request('POST', 'potential-drivers/addFile', body, {}, (form) => form);
    },
    removeFile: (id, filePath) => request(
        'POST',
        `potential-drivers/removeFile?potentialDriverId=${id}&filePath=${encodeURIComponent(filePath)}`,
    ),
    download: (id, filePath) => request(
        'POST',
        `potential-drivers/getFile?potentialDriverId=${id}&filePath=${encodeURIComponent(filePath)}`,
        null,
        null,
        null,
        true,
    ),
};
